import React, {Fragment, useState, useEffect, Suspense} from 'react';
import {useDropzone} from 'react-dropzone';

import _ from 'lodash';
import {Button} from 'core/controls';
import axios from 'api';
import {Modal, Spinner} from 'core/uicore';
import {closeIcon} from 'assets';

const FileViewer = React.lazy(() => import('react-file-viewer'));

const getMimeType = (fileType) => {
  let accept = undefined;
  switch (fileType) {
    case 'P':
      accept = 'application/pdf';
      break;
    case 'D':
      accept = 'application/vnd.openxmlformats-officedocument.wordprocessingml.document, application/msword';
      break;
    case 'I':
      accept = 'image/jpeg, image/png';
      break;
    case '*':
    default:
      break;
  }
  return accept;
};

const FilePicker = ({name, controlChange, controlGetFocus, controlLostFocus, controlClick, setElement, formData}) => {
  const {acceptedFiles, getRootProps, open, getInputProps} = useDropzone({
    accept: getMimeType(formData['cboFileType']),
    noClick: true,
    noKeyboard: true,
  });
  const [isPreview, setIsPreview] = useState(false);
  const [previewFile, setPreviewFile] = useState({name: '', type: ''});
  const url = window.location.origin;

  useEffect(() => {
    let newFile = [];
    console.log(acceptedFiles);
    if (acceptedFiles.length > 0) {
      if (formData[name].length > 0) {
        newFile = formData[name].filter((file) => file.fileName === acceptedFiles[0].name);
      }
      if (newFile.length === 0) {
        let tempFiles = [...formData[name]];
        tempFiles.push({
          fileName: acceptedFiles[0].name,
          size: acceptedFiles[0].size,
          documentType: formData['cboDocumentType'],
          fileType: formData['cboFileType'],
        });
        let event = {
          target: {
            value: tempFiles,
            name,
          },
        };
        controlChange(event, name, tempFiles);

        //API call for file upload
        if (acceptedFiles.length > 1) {
        } else if (acceptedFiles.length === 1) {
          let f = new FormData();
          f.append('File', acceptedFiles[0]);
          f.append('FileDirectory', formData['policyNumber']);
          try {
            let policy = axios.post('/api/files/Upload', f, {headers: {'Content-Type': 'multipart/form-data'}});
          } catch (error) {
            console.log('upload error = ', error);
          }
        }
      }
    }
  }, [acceptedFiles]);

  const deleteFile = (event, idx) => {
    let tempFiles = formData[name].filter((file, id) => id !== idx);
    // setFiles(tempFiles);
    let file = new File(['This is dummy content'], formData[name][idx].fileName);
    console.log('Delete File', file);
    let f = new FormData();
    f.append('File', file);
    f.append('FileDirectory', formData['policyNumber']);
    try {
      let policy = axios.post('/api/files/DeleteFile', f, {headers: {'Content-Type': 'multipart/form-data'}});
    } catch (error) {
      console.log('upload error = ', error);
    }
    controlChange(event, name, tempFiles);
  };
  const clickPreview = (name) => {
    const typeArr = name.split('.');
    const type = typeArr[typeArr.length - 1];
    setPreviewFile({name, type});

    setTimeout(() => setIsPreview(true), 500);
  };
  const cancelPreview = () => {
    setIsPreview(false);
    setPreviewFile({name: '', type: ''});
  };
  let fileList;
  if (!formData || !formData[name] || formData[name.length === 0]) {
    fileList = undefined;
  } else {
    fileList = formData[name].map((file, idx) => {
      console.log(file);
      return (
        <li key={file.fileName}>
          {file.fileName} - {file.size} bytes
          <div className='flexContainer noCols'>
            <Button
              text='X'
              getfocusCallback={() => {}}
              getclickCallback={(event, name, value) => {
                deleteFile(event, idx);
                controlClick(event, name, value);
              }}
              lostfocusCallback={() => {}}
              name='btnFileDelete'
              refItem={() => {}}
              propStyle={{
                label: 'buttonlabel',
                control: `buttonControl`,
              }}
            />
            <Button
              text='Preview'
              getfocusCallback={() => {}}
              getclickCallback={(event, name, value) => {
                clickPreview(file.fileName);
                controlClick(event, name, value);
              }}
              lostfocusCallback={() => {}}
              name='btnFilePreview'
              refItem={() => {}}
              propStyle={{
                label: 'buttonlabel',
                control: `buttonControl`,
              }}
            />
          </div>
        </li>
      );
    });
  }

  // console.log(formData[name]);
  return (
    <section className='container'>
      <div {...getRootProps({className: 'dropzone'})}>
        <input {...getInputProps()} />
        <p>Drag 'n' drop some files here, or click to select files</p>
        <Button
          text='Attach'
          getfocusCallback={controlGetFocus}
          getclickCallback={(event, name, value) => {
            open(event);
            controlClick(event, name, value);
          }}
          lostfocusCallback={controlLostFocus}
          stateData={formData}
          name='btnAttachFile'
          refItem={setElement}
          propStyle={{
            label: 'buttonlabel',
            control: `buttoncontrol bgPrimaryColor borderRadiusAll`,
          }}
          allowPropagation={true}
        />
      </div>
      <aside>
        <h4>Files</h4>
        <ul>{fileList}</ul>
      </aside>
      {isPreview && (
        <Modal onClick={(e) => e.stopPropagation()} propStyle='modalDark'>
          <div className='modalcontainer paddingLg borderRadiusAllLg'>
            <Button
              text='Cancel'
              getfocusCallback={() => {}}
              getclickCallback={(event, name, value) => {
                cancelPreview();
                controlClick(event, name, value);
              }}
              lostfocusCallback={() => {}}
              name='btnCancelFilePickerPreview'
              refItem={() => {}}
              propStyle={{
                label: 'buttonlabel',
                control: `modalClose`,
              }}
              logo={{
                srcLogo: closeIcon,
                altLogo: '',
                classLogo: 'new-logo',
              }}
              showIcon={true}
            />
            <Suspense fallback={<Spinner />}>
              <FileViewer className='modalWrapper' fileType={previewFile.type} filePath={`${url}/Policies/${formData['policyNumber']}/${previewFile.name}`} />
            </Suspense>
          </div>
        </Modal>
      )}
    </section>
  );
};

export {FilePicker};
